import { render, staticRenderFns } from "./Example.vue?vue&type=template&id=6351d4ae&scoped=true&"
import script from "./Example.vue?vue&type=script&lang=js&"
export * from "./Example.vue?vue&type=script&lang=js&"
import style0 from "./Example.vue?vue&type=style&index=0&id=6351d4ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6351d4ae",
  null
  
)

export default component.exports